import { Fade, Link, Stack, Typography } from '@mui/material'
import { Box } from '@mui/system'
import { batch } from 'react-redux'
import { useAppDispatch } from 'app/hooks'
import { useSelector } from 'react-redux'
import { clearFilters } from 'app/thunks'
import { useHistory } from 'react-router'
import { getSelectBaseUri } from 'app/selectors'

const NoResults = () => {
  const dispatch = useAppDispatch()
  const history = useHistory()
  const baseUri = useSelector(getSelectBaseUri())

  return (
    <Box p={1} bgcolor="grey.200">
      <Fade in>
        <Stack flexDirection={'row'} justifyContent={'center'}>
          <Typography variant={'large'}>
            No products were found with the current filters.
          </Typography>
          <Link
            fontWeight={'700'}
            variant={'large'}
            ml={2}
            sx={{ cursor: 'pointer' }}
            onClick={() => {
              batch(() => {
                history.push(baseUri)
                dispatch(clearFilters())
              })
            }}
          >
            Clear filters?
          </Link>
        </Stack>
      </Fade>
    </Box>
  )
}

export default NoResults
